import React from 'react';

const ExpanderCollapsedIcon: React.FC = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.5"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
		role="presentation"
	>
		<path d="M9 18L15 12L9 6" />
	</svg>
);

export default ExpanderCollapsedIcon;
